<template>
  <el-dialog title="作废" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        ref="form2" label-width="130px">
        <el-row>
          <el-col :span="24" key="4">
            <el-form-item label="附件" :rules="{ required: true, message: '请上传附件', trigger: 'blur' }">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>

  </el-dialog>
</template>
<script>
export default {
  props: {
    pickupId: {
      type: String,
      default: ''
    },
    showDlg: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data() {
    return {
      formData: {
        fileList: []
      },
      loading: false
    }
  },
  computed: {
  },
  created() {
    console.log(this.$apis.deliveryOrder.ZfYxPickupOrder)
  },
  methods: {
    handleClose() {
      this.$emit('closeDlg')
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        this.loading = true
        if (!this.formData.fileList.length) {
          this.$message.error('请上传附件')
          this.loading = false
        } else {
          this.$axios.post(this.$apis.deliveryOrder.ZfYxPickupOrder, {
            pickupId: this.pickupId,
            ...this.formData
          }).then(() => {
            this.$emit('successSave')
            this.handleClose()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}
</style>
